<template>
  <div id="app">
    <el-container>
      <el-header class="topHeader">
        <div class="logoBox">
          {{ userData.name }}
        </div>
        <el-menu default-active="7-1" background-color="#1e2657" text-color="#fff"
          active-text-color="#567df1" class="el-menu-demo" mode="horizontal">
          <el-menu-item index="1">工作台</el-menu-item>
          <el-submenu index="2">
            <template slot="title">菜水进销存</template>
            <el-menu-item index="2-1"></el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">桌椅分布</template>
            <el-menu-item index="3-1"></el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">在线菜单</template>
            <el-menu-item index="4-1"></el-menu-item>
          </el-submenu>
          <el-submenu index="7">
            <template slot="title">订单管理</template>
            <el-menu-item index="7-1">销售订单</el-menu-item>
            <el-menu-item index="7-2">订单统计</el-menu-item>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">会员统计</template>
            <el-menu-item index="5-1"></el-menu-item>
          </el-submenu>
          <el-submenu index="6">
            <template slot="title">员工管理</template>
            <el-menu-item index="6-1"></el-menu-item>
          </el-submenu>
          <el-submenu index="8">
            <template slot="title">系统管理</template>
            <el-menu-item index="8-1"></el-menu-item>
          </el-submenu>
        </el-menu>
        <div @click="back" class="rightName">
          <img src="./assets/tx.png" class="txImg" alt="">
          <i class="el-icon-caret-bottom userIcon"></i>
        </div>
      </el-header>
      <el-container>
        <el-main>
          <Demo />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Demo from './components/Demo'
export default {
    components: {
        Demo
    },
    data() {
        return {
            userData: {
              name: '餐饮有限公司'
            }
        }
    },
    mounted() {
        window.addEventListener('message', e => {
        if (e.data.msgType == 'userInfo') {
            this.userData = e.data.info
        }
        })
    },
    methods: {
        back() {
            window.parent.postMessage({
				type: 'LogOut'
			}, "*");
        }
    },
    beforeDestroy() {
        window.removeEventListener('message')
    },
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
#app {
  font-family: Helvetica, sans-serif;
  text-align: center;
  background: #fff;
}
.el-menu-demo{
  flex: 1;
  display: flex;
  justify-content: center;
}
.el-container{
  height: 100vh;
  overflow: hidden;
}
.el-container .el-aside .el-menu{
  height: 100%;
  background: #fff;
}
.topHeader{
  display: flex;
  align-items: center;
  background: #1e2657;
}
.logoBox{
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  font-style: italic;
}
.rightName{
  font-size: 14px;
  margin-left: auto;
  display: flex;
  align-items: center;
  color: #fff;
}
.userIcon{
  font-size: 16px;
  margin-left: 5px;
}
.txImg{
  width: 40px;
  margin-right: 2px;
}
.el-submenu__title{
  display: flex;
  align-items: center;
}
.el-main{
  background: #f5f5f5;
}
.el-button--primary{
  background: #567df1;
  border: 1px solid #567df1;
}
.el-button--text, .el-pagination.is-background .el-pager li:not(.disabled):hover{
  color: #567df1;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #567df1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue